import React from 'react';
import { Button, Menu, MenuItem } from '@mui/material';
import { KeyboardArrowDown } from '@mui/icons-material';
import ImportSubEventsButton from './ImportSubEventsButton';
import ImportSubEventsButtonJSON from './ImportSubEventsButtonJSON';
import ImportFromLiveloxButton from './ImportFromLiveloxButton';
import auth from 'services/auth';

const ImportSubEventsMenu = () => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  if (!auth.hasPermission('event:import_subevents')) {
    return null;
  }

  return (
    <React.Fragment>
      <Button variant="outlined" endIcon={<KeyboardArrowDown />} onClick={(e) => setAnchorEl(e.currentTarget)}>
        Import
      </Button>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        <MenuItem disableRipple sx={{ display: 'block', py: 0.5 }}>
          <ImportSubEventsButton />
        </MenuItem>
        <MenuItem disableRipple sx={{ display: 'block', py: 0.5 }}>
          <ImportSubEventsButtonJSON />
        </MenuItem>
        {auth.hasPermission('event:import_livelox') && (
          <MenuItem disableRipple sx={{ display: 'block', py: 0.5 }}>
            <ImportFromLiveloxButton />
          </MenuItem>
        )}
      </Menu>
    </React.Fragment>
  );
};

export default ImportSubEventsMenu;
